export enum ROUTES {
  DEPOSIT = '/deposit',
  WITHDRAW = '/withdraw',
  CONVERT = '/convert',
  BUY = '/buy',
  SELL = '/sell',
}
